/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StudentCreditsResponse } from "../models/StudentCreditsResponse";
import type { StudentSubjectAdminResponse } from "../models/StudentSubjectAdminResponse";
import type { StudentSubjectCreate } from "../models/StudentSubjectCreate";
import type { StudentSubjectPublicResponse } from "../models/StudentSubjectPublicResponse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class StudentSubjectsService {
  /**
   * Get Student Subject
   * Retrieve a student subject.
   * @returns StudentSubjectAdminResponse Successful Response
   * @throws ApiError
   */
  public static getStudentSubject({
    studentId,
    orgSubjectId,
  }: {
    studentId: number;
    orgSubjectId: number;
  }): CancelablePromise<StudentSubjectAdminResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/student_subjects",
      query: {
        student_id: studentId,
        org_subject_id: orgSubjectId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Get Student Subjects By Student Id
   * Retrieve a student subject.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static getStudentSubjectsByStudentId({
    studentId,
    active,
  }: {
    studentId: number;
    active?: boolean | null;
  }): CancelablePromise<
    Array<StudentSubjectAdminResponse> | Array<StudentSubjectPublicResponse>
  > {
    return __request(OpenAPI, {
      method: "GET",
      url: "/student_subjects/student/{student_id}",
      path: {
        student_id: studentId,
      },
      query: {
        active: active,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Get Student Credits By Org
   * Get all student subjects by org.
   * @returns StudentCreditsResponse Successful Response
   * @throws ApiError
   */
  public static getStudentCreditsByOrg({
    orgId,
  }: {
    orgId: number;
  }): CancelablePromise<Array<StudentCreditsResponse>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/student_subjects/credits/organization/{org_id}",
      path: {
        org_id: orgId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Create Student Subject
   * Create a new student subject.
   * @returns StudentSubjectAdminResponse Successful Response
   * @throws ApiError
   */
  public static createStudentSubject({
    requestBody,
  }: {
    requestBody: StudentSubjectCreate;
  }): CancelablePromise<StudentSubjectAdminResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/student_subjects/create",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Set Custom Subject Bill Rate For Student
   * Set a custom bill rate for a student on a given subject.
   * If custom_bill_rate is None, a student's meetings will be
   * updated to reflect the default price for that subject.
   * @returns StudentSubjectAdminResponse Successful Response
   * @throws ApiError
   */
  public static setCustomSubjectBillRateForStudent({
    studentId,
    orgSubjectId,
    customBillRate,
  }: {
    studentId: number;
    orgSubjectId: number;
    customBillRate?: number | null;
  }): CancelablePromise<StudentSubjectAdminResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/student_subjects/set_custom_subject_bill_rate_for_student/{student_id}",
      path: {
        student_id: studentId,
      },
      query: {
        org_subject_id: orgSubjectId,
        custom_bill_rate: customBillRate,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Toggle Student Subject Active
   * Toggle the active status of a student subject.
   * @returns StudentSubjectPublicResponse Successful Response
   * @throws ApiError
   */
  public static toggleStudentSubjectActive({
    studentId,
    orgSubjectId,
    active,
  }: {
    studentId: number;
    orgSubjectId: number;
    active: boolean;
  }): CancelablePromise<StudentSubjectPublicResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/student_subjects/toggle_active/{student_id}",
      path: {
        student_id: studentId,
      },
      query: {
        org_subject_id: orgSubjectId,
        active: active,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }
}
